<template>
    <step-container>
        <step-info
            :label="stepLabel"
            :large-label="stepLabelLarge"
        />

        <transition name="cz3__fade-fast-slide" mode="out-in">
            <design-main-toolbar
                v-if="selectedSubStep === 'choose' && largeScreen"
                :surface-index="surfaceIndex"
                :design-on="designOn"
            />
        </transition>

        <transition name="cz3__fade-fast-slide" mode="out-in">
            <design-all-text-toolbar
                v-if="selectedSubStep && selectedSubStep.startsWith('text')"
                class="cz3__hide-sm"
            />
        </transition>

        <transition name="cz3__fade-fast-slide" mode="out-in">
            <design-all-monogram-toolbar
                v-if="selectedSubStep && selectedSubStep.startsWith('monogram')"
                class="cz3__hide-sm"
            />
        </transition>

        <transition name="cz3__fade-fast-slide" mode="out-in">
            <design-all-image-toolbar
                v-if="selectedSubStep && selectedSubStep.startsWith('gallery')"
                class="cz3__hide-sm"
            />
        </transition>

        <transition name="cz3__fade-fast-slide" mode="out-in">
            <design-all-upload-toolbar
                v-if="selectedSubStep && selectedSubStep.startsWith('upload')"
                class="cz3__hide-sm"
            />
        </transition>

        <transition name="cz3__fade-fast-slide" mode="out-in">
            <design-main-toolbar
                v-if="selectedSubStep === 'choose' && !largeScreen"
                :surface-index="surfaceIndex"
                :design-on="designOn"
            />

            <design-text-entry-toolbar v-if="selectedSubStep === 'text'"
                class="cz3__hide-lg"
                :buttons-sm="true"
            />

            <design-text-color-toolbar v-if="selectedSubStep === 'text-color'"
                class="cz3__hide-lg"
                :buttons-sm="true"
            />

            <design-text-font-toolbar v-if="selectedSubStep === 'text-font'"
                class="cz3__hide-lg"
                :buttons-sm="true"
            />

            <design-text-alignment-toolbar v-if="selectedSubStep === 'text-alignment'"
                class="cz3__hide-lg"
                :buttons-sm="true"
            />

            <design-monogram-entry-toolbar v-if="selectedSubStep === 'monogram'"
                class="cz3__hide-lg"
                :buttons-sm="true"
            />

            <design-monogram-color-toolbar v-if="selectedSubStep === 'monogram-color'"
                class="cz3__hide-lg"
                :buttons-sm="true"
            />

            <design-monogram-font-toolbar v-if="selectedSubStep === 'monogram-font'"
                class="cz3__hide-lg"
                :buttons-sm="true"
            />

            <design-monogram-alignment-toolbar v-if="selectedSubStep === 'monogram-alignment'"
                class="cz3__hide-lg"
                :buttons-sm="true"
            />

            <design-image-alignment-toolbar v-if="selectedSubStep === 'gallery-alignment'"
                class="cz3__hide-lg"
                :buttons-sm="true"
            />

            <design-image-color-toolbar v-if="selectedSubStep === 'gallery-color'"
                class="cz3__hide-lg"
                :buttons-sm="true"
            />

            <design-upload-toolbar v-if="selectedSubStep === 'upload'"
                class="cz3__hide-lg"
                :buttons-sm="true"
            />

            <design-upload-alignment-toolbar v-if="selectedSubStep === 'upload-alignment'"
                class="cz3__hide-lg"
                :buttons-sm="true"
            />
        </transition>
    </step-container>
</template>

<script>
    import StepContainer from './StepContainer.vue';
    import StepInfo from './StepInfo.vue';
    import DesignMainToolbar from './DesignMainToolbar.vue';
    import DesignImageAlignmentToolbar from './DesignImageAlignmentToolbar.vue';
    import DesignImageColorToolbar from './DesignImageColorToolbar.vue';
    import DesignTextEntryToolbar from './DesignTextEntryToolbar.vue';
    import DesignTextColorToolbar from './DesignTextColorToolbar.vue';
    import DesignTextFontToolbar from './DesignTextFontToolbar.vue';
    import DesignTextAlignmentToolbar from './DesignTextAlignmentToolbar.vue';
    import DesignMonogramEntryToolbar from './DesignMonogramEntryToolbar.vue';
    import DesignMonogramColorToolbar from './DesignMonogramColorToolbar.vue';
    import DesignMonogramFontToolbar from './DesignMonogramFontToolbar.vue';
    import DesignMonogramAlignmentToolbar from './DesignMonogramAlignmentToolbar.vue';
    import DesignUploadToolbar from './DesignUploadToolbar.vue';
    import DesignUploadAlignmentToolbar from './DesignUploadAlignmentToolbar.vue';
    import DesignAllTextToolbar from './DesignAllTextToolbar.vue';
    import DesignAllImageToolbar from './DesignAllImageToolbar.vue';
    import DesignAllMonogramToolbar from './DesignAllMonogramToolbar.vue';
    import DesignAllUploadToolbar from './DesignAllUploadToolbar.vue';

    export default {
        components: {
            StepContainer,
            StepInfo,
            DesignMainToolbar,
            DesignImageAlignmentToolbar,
            DesignImageColorToolbar,
            DesignAllTextToolbar,
            DesignTextEntryToolbar,
            DesignTextColorToolbar,
            DesignTextFontToolbar,
            DesignTextAlignmentToolbar,
            DesignMonogramEntryToolbar,
            DesignMonogramColorToolbar,
            DesignMonogramFontToolbar,
            DesignMonogramAlignmentToolbar,
            DesignUploadToolbar,
            DesignUploadAlignmentToolbar,
            DesignAllImageToolbar,
            DesignAllUploadToolbar,
            DesignAllMonogramToolbar,
        },

        props: {
            designIndex: Number,
            surfaceIndex: Number,
        },

        data() {
            return {
                designOn: null,
            };
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            selectedStep() {
                return this.$store.state.selectedStepV3;
            },

            selectedSubStep() {
                return this.$store.state.selectedSubStepV3;
            },

            availableSides() {
                return this.$store.getters.availableSidesV3;
            },

            personalizationMethod() {
                return this.$store.state.customizer.personalizationMethod;
            },

            stepLabel() {
                if (this.selectedSubStep === 'choose') {
                    if (this.personalizationMethod === 'printing') {
                        const step = this.availableSides[this.designIndex];

                        if (step === 'front') {
                            return this.$t('V3_DESIGN_FRONT');
                        }

                        return this.$t('V3_DESIGN_BACK');
                    }

                    if (this.personalizationMethod === 'etching') {
                        const step = this.availableSides[this.designIndex];

                        const firstOrSecond = this.surfaceIndex === 0 ? this.$t('V3_DESIGN_FIRST') : this.$t('V3_DESIGN_SECOND');

                        if (step === 'front') {
                            return `${this.$t('V3_DESIGN_FRONT')}${firstOrSecond}`;
                        }

                        if (step === 'back') {
                            return `${this.$t('V3_DESIGN_BACK')}${firstOrSecond}`;
                        }

                        if (step === 'backtop') {
                            return `${this.$t('V3_DESIGN_BACK_TOP')}${firstOrSecond}`;
                        }

                        return this.$t('V3_DESIGN_BACK');
                    }

                    return this.$t('V3_DESIGN_FIRST_OPTION');
                }

                if (this.selectedSubStep === 'gallery-alignment') {
                    return this.$t('V3_STEP_IMAGE_ALIGNMENT');
                }

                if (this.selectedSubStep === 'gallery-color') {
                    return this.$t('V3_STEP_IMAGE_COLOR');
                }

                if (this.selectedSubStep === 'text') {
                    return this.$t('V3_EDIT_TEXT');
                }

                if (this.selectedSubStep === 'text-color') {
                    return this.$t('V3_EDIT_TEXT_COLOR');
                }

                if (this.selectedSubStep === 'text-font') {
                    return this.$t('V3_EDIT_TEXT_FONT');
                }

                if (this.selectedSubStep === 'text-alignment') {
                    return this.$t('V3_EDIT_TEXT_ALIGNMENT');
                }

                if (this.selectedSubStep === 'monogram') {
                    return this.$t('V3_EDIT_MONOGRAM');
                }

                if (this.selectedSubStep === 'monogram-color') {
                    return this.$t('V3_EDIT_MONOGRAM_COLOR');
                }

                if (this.selectedSubStep === 'monogram-font') {
                    return this.$t('V3_EDIT_MONOGRAM_FONT');
                }

                if (this.selectedSubStep === 'monogram-alignment') {
                    return this.$t('V3_EDIT_MONOGRAM_ALIGNMENT');
                }

                if (this.selectedSubStep === 'upload') {
                    return this.$t('V3_EDIT_UPLOAD');
                }

                if (this.selectedSubStep === 'upload-alignment') {
                    return this.$t('V3_STEP_IMAGE_ALIGNMENT');
                }

                return '';
            },

            stepLabelLarge() {
                if (this.selectedSubStep === 'choose') {
                    if (this.personalizationMethod === 'printing') {
                        const step = this.availableSides[this.designIndex];

                        if (step === 'front') {
                            return this.$t('V3_DESIGN_FRONT');
                        }

                        return this.$t('V3_DESIGN_BACK');
                    }

                    if (this.personalizationMethod === 'etching') {
                        const step = this.availableSides[this.designIndex];

                        const firstOrSecond = this.surfaceIndex === 0 ? this.$t('V3_DESIGN_FIRST') : this.$t('V3_DESIGN_SECOND');

                        if (step === 'front') {
                            return `${this.$t('V3_DESIGN_FRONT')}${firstOrSecond}`;
                        }

                        if (step === 'back') {
                            return `${this.$t('V3_DESIGN_BACK')}${firstOrSecond}`;
                        }

                        if (step === 'backtop') {
                            return `${this.$t('V3_DESIGN_BACK_TOP')}${firstOrSecond}`;
                        }

                        return this.$t('V3_DESIGN_BACK');
                    }

                    return this.$t('V3_DESIGN_FIRST_OPTION');
                }

                if (this.selectedSubStep === 'gallery') {
                    return this.$t('V3_GRAPHIC_GALLERY_LARGE');
                }

                if (this.selectedSubStep === 'gallery-alignment') {
                    return this.$t('V3_GRAPHIC_GALLERY_LARGE');
                }

                if (this.selectedSubStep === 'upload-alignment') {
                    return this.$t('V3_STEP_IMAGE_ALIGNMENT');
                }

                if (this.selectedSubStep === 'gallery-color') {
                    return this.$t('V3_STEP_IMAGE_COLOR');
                }

                if (this.selectedSubStep === 'text') {
                    return this.$t('V3_CUSTOMIZE_TEXT');
                }

                if (this.selectedSubStep === 'text-color') {
                    return this.$t('V3_CUSTOMIZE_TEXT');
                }

                if (this.selectedSubStep === 'text-font') {
                    return this.$t('V3_CUSTOMIZE_TEXT');
                }

                if (this.selectedSubStep === 'text-alignment') {
                    return this.$t('V3_CUSTOMIZE_TEXT');
                }

                if (this.selectedSubStep === 'monogram') {
                    return this.$t('V3_CUSTOMIZE_MONOGRAM');
                }

                if (this.selectedSubStep === 'monogram-color') {
                    return this.$t('V3_CUSTOMIZE_MONOGRAM');
                }

                if (this.selectedSubStep === 'monogram-font') {
                    return this.$t('V3_CUSTOMIZE_MONOGRAM');
                }

                if (this.selectedSubStep === 'monogram-alignment') {
                    return this.$t('V3_CUSTOMIZE_MONOGRAM');
                }

                if (this.selectedSubStep === 'upload') {
                    return this.$t('V3_CUSTOMIZE_UPLOAD');
                }

                return '';
            },

            nextStep() {
                return this.$store.getters.nextStepV3;
            },

            prevStep() {
                return this.$store.getters.prevStepV3;
            },

            largeScreen() {
                return this.$store.state.windowWidth >= 1024;
            },
        },

        beforeMount() {
            this.$store.dispatch('setSelectedSubStepV3', 'choose');
            this.$store.dispatch('editPlacement', null);

            const designOn = this.availableSides[this.designIndex];

            this.designOn = designOn;

            this.$store.dispatch('switchToDesignView', designOn);
        },

        mounted() {
            this.$store.dispatch('lockSwipe', true);
        },

        beforeDestroy() {
        },

        methods: {
        },
    };
</script>
